import * as React from 'react';
import moment from 'moment';
import {Form, Formik} from 'formik';
import styled from 'styled-components';
import Tab from "components/Tab";
import Tabbar from "components/Tabbar";
import {StyledContainer as BaseContainer} from 'containers/Container';
import Plan from './components/Plan';
import Constructor from './components/Constructor';
import {getLocalStorageTariffs} from "./helpers";
import {TariffsValues} from "./types";
import MonthEnd from "./components/MonthEnd";
import {Helmet} from 'react-helmet';

const Content = styled(BaseContainer)`
  width: 100%;
  display: grid;
  gap: 30px;
  margin-bottom: 80px;
`;

/**
 * The courses page
 * @param {TariffsValues} props
 * @constructor
 */
export default function Tariffs(props: TariffsValues | any)
  : React.ReactElement {
  const initialValues: TariffsValues = {
    current: {
      autoRenewal: true,
      limits: {
        students: 500,
        storage: 5000,
      },
      used: {
        students: 150,
        storage: 4000,
      },
      paidBy: moment('09.09.2021', 'DD.MM.YYYY'),
    },

    selected: getLocalStorageTariffs(),
  };

  /**
   * submit tariffs form
   * @param {Partial<TariffsValues>} values
   * @constructor
   */
  function handleSubmit(values: Partial<TariffsValues>) {
    console.log('values', values);
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>GrowPlace / Тарифы</title>
      </Helmet>
      <Formik <Partial<TariffsValues>>
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form>
            <Content>
              <Plan />
              <Tabbar >
                <Tab name={'constructor'} title={'Конструктор тарифа'}>
                  <Constructor />
                </Tab>
                <Tab name={'monthEnd'} title={'Оплата в конце месяца'}>
                  <MonthEnd />
                </Tab>
              </Tabbar>
            </Content>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}
